export default __webpack_public_path__ + "static/media/submit.1482a2e6.svg";